import React, { useState, useEffect, useRef } from "react";
import PrimaryHeading from '../../../components/common/primaryHeading';
import ButtonWithSearch from '../../../components/common/buttonWithSearch';
import DataGrid from '../../../components/common/dataGrid/dataGrid';
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import './NotificationHistory.scss';
import { commonPostApi } from "../../../utils/apiService";
import { API_ENDPOINTS } from "../../../utils/apiEndpoints";
import { SORT_ORDER } from "../../../constants/sortOrder";

const NotificationHistory = () => {
  const menuLeft = useRef(null);
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 0,
    sortBy: 'created_at',
    sortDir: SORT_ORDER.DESC,
    searchCriteria: {},
  });

  const userColumns = [
    {
      name: 'serial_number',
      label: 'S.No',
      sortable: true  // Make serial number column non-sortable
    },
    {
      name: 'notification_title',
      label: 'Title',
      sortable: true   // Make title column sortable
    },
    {
      name: 'notification_description',
      label: 'Description',
      sortable: true   // Make description column sortable
    },
    {
      name: 'notification_users',
      label: 'Users',
      sortable: true   // Make users column sortable
    },
    {
      name: 'notification_camps',
      label: 'Camps',
      sortable: true   // Make camps column sortable
    },
    {
      name: 'scheduler_type',
      label: 'Scheduler',
      sortable: true   // Make scheduler column sortable
    },
  ];

  // Custom column callback for serial number
  const columnCallBack = (rowData, column) => {
    if (column.name === 'serial_number') {
      const rowIndex = userData.findIndex(item => item === rowData);
      const currentPage = navigator.page;
      const rowsPerPage = navigator.rows;
      const serialNumber = (currentPage - 1) * rowsPerPage + rowIndex + 1;
      return serialNumber;
    }
    if (column.name === 'notification_camps') {
      const camps = rowData?.notification_camps;
      if (Array.isArray(camps)) {
        const campNames = camps.map(c => typeof c === 'string' ? c : (c?.camp_name || c?.name || ''));
        return campNames.filter(Boolean).join(', ');
      }
      return camps;
    }
    if (column.name === 'notification_users') {
      const users = rowData?.notification_users;
      if (Array.isArray(users)) {
        const userNames = users.map(u => typeof u === 'string' ? u : (u?.user_name || u?.name || ''));
        return userNames.filter(Boolean).join(', ');
      }
      return users;
    }
    return rowData[column.name];
  };



  const handleView = (rowData) => {
    const rowIndex = userData.findIndex(item => item === rowData);
    const currentPage = navigator.page;
    const rowsPerPage = navigator.rows;
    const serialNumber = (currentPage - 1) * rowsPerPage + (rowIndex >= 0 ? rowIndex : 0) + 1;

    navigate('/notifications/view', { state: { notification: { ...rowData, serial_number: serialNumber } } });
  };

  const itemRenderer = (item, prop) => (
    <div className="p-menuitem-content">
      {item.label === "View" && (
        <Button
          className="card-button-assign-role"
          label="View"
          onClick={() => {
            handleView(prop?.props?.itemProp);
          }}
        />
      )}
    </div>
  );

  // Initial load
  useEffect(() => {
    getNotificationHistory();
  }, []);

  const getNotificationHistory = async (navParams = navigator) => {
    try {
      setLoading(true);

      // Prepare query object as expected by backend
      const queryData = {
        page: navParams.page,
        limit: navParams.rows,
        sortFields: [[navParams.sortBy, navParams.sortDir.toUpperCase()]],
        searchCriteria: navParams.searchCriteria,
      };

      const res = await commonPostApi(API_ENDPOINTS.GET_NOTIFICATION_HISTORY, { query: queryData });
      console.log("Notification History", res);

      if (res?.data?.data) {
        setUserData(res?.data?.data);
        // Update totalRecords from API response
        setNavigator(prev => ({
          ...prev,
          totalRecords: res?.data?.total || 0,
          page: res?.data?.currentPage || 1,
        }));
      }
    } catch (err) {
      console.log("Notification History Error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    const newNavigator = {
      ...navigator,
      page: 1,
      first: 0,
      searchCriteria: value ? {
        notification_title: value,
        notification_description: value,
        notification_users: value,
        notification_camps: value,
        scheduler_type: value
      } : {},
    };
    setNavigator(newNavigator);
    getNotificationHistory(newNavigator);
  };

  const onSortClick = (event) => {
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    const newNavigator = {
      ...navigator,
      sortBy: event?.sortField || 'created_at',
      sortDir: sortOrder,
    };
    setNavigator(newNavigator);
    getNotificationHistory(newNavigator);
  };

  const onPageChange = (event) => {
    const newNavigator = {
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    };
    setNavigator(newNavigator);
    getNotificationHistory(newNavigator);
  };

  const onRowCountChange = (e) => {
    const newNavigator = {
      ...navigator,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    };
    setNavigator(newNavigator);
    getNotificationHistory(newNavigator);
  };

  return (
    <div className=" notification-history-container">
      <PrimaryHeading className={"mt-5 mb-3"} />
      <div className="mt-3 " style={{ color: "rgba(47, 43, 61, 0.9)" }}>
        <DataGrid
          header={
            <ButtonWithSearch
              searchHeaderLable={"Notification History"}
              searchPlaceHolder={"Search Notifications"}
              isSearchEnabled={true}
              isCalenderEnabled={false}
              isButtonEnabledLeft={false}
              isButtonEnabledRight={true}
              onChange={handleSearchChange}
            />
          }
          column={userColumns}
          value={userData}
          showDownloadButton={false}
          navigator={navigator}
          onSortClick={onSortClick}
          onPageChange={onPageChange}
          onRowCountChange={onRowCountChange}
          loading={loading}
          ref={menuLeft}
          selectable={false}
          isPaginatorEnabled={true}
          customColumn={['serial_number', 'notification_camps', 'notification_users']}
          columnCallBack={columnCallBack}
          optionsView={[
            {
              items: [
                {
                  label: "View",
                  icon: "pi pi-eye",
                  template: itemRenderer,
                },
              ],
            },
          ]}
        />
      </div>
    </div>
  );
};

export default NotificationHistory; 